export default [
    {
        title: 'Prise de commande',
        route: 'new-order',
        action: 'page',
        tag: '0',
        resource: 'new-order',
        icon: 'ShoppingCartIcon',
        tagVariant: 'success',
    },
    {
        title: 'Actualités',
        icon: 'StarIcon',
        resource: 'arrivals',
        action: 'page',
        route: 'arrivals',
    },
    {
        title: 'Documents',
        icon: 'FileTextIcon',
        children: [
            {
                title: 'Bon de Commande',
                route: 'docs-orders',
                // icon: 'FileIcon',
                action: 'page',
                resource: 'docs-orders',
            },
            {
                title: 'Bon de Livraison',
                route: 'docs-shipments',
                // icon: 'FileTextIcon',
                action: 'page',
                resource: 'docs-shipments',
            },
            {
                title: 'Retours',
                route: 'docs-returns',
                // icon: 'FileTextIcon',
                action: 'page',
                resource: 'docs-returns',
            },
            {
                title: 'Factures',
                route: 'docs-invoices',
                // icon: 'FileMinusIcon',
                action: 'page',
                resource: 'docs-invoices',
            },
            {
                title: 'Factures validées',
                route: 'docs-validated-invoices',
                // icon: 'FileMinusIcon',
                action: 'page',
                resource: 'docs-validated-invoices',
            },
            {
                title: 'Avoirs',
                route: 'docs-credit-memos',
                // icon: 'FilePlusIcon',
                action: 'page',
                resource: 'docs-credit-memos',
            },
            {
                title: 'Avoirs validés',
                route: 'docs-validated-credit-memos',
                // icon: 'FilePlusIcon',
                action: 'page',
                resource: 'docs-validated-credit-memos',
            },
        ],
    },
    {
        title: 'Réclamations',
        route: 'claims',
        icon: 'FeatherIcon',
        action: 'page',
        resource: 'claims',
    },
]
